module.exports = __webpack_public_path__ + "media/images/writer/community/pc-headline-about-rule@2x-da0b8273a8ed9340dcbfa068f407d255.png";